import _regeneratorRuntime from '/app/node_modules/babel-runtime/regenerator';
import _asyncToGenerator from '/app/node_modules/babel-runtime/helpers/asyncToGenerator';
import _Object$keys from '/app/node_modules/babel-runtime/core-js/object/keys';
import _Object$assign from '/app/node_modules/babel-runtime/core-js/object/assign';
//
//
//
//


import axios from '~/plugins/axios';

import PageCatalogInner from '~/components/pages/PageCatalogInner.vue';
import PageNewsInner from '~/components/pages/PageNewsInner.vue';
import PageMaterialsInner from '~/components/pages/PageMaterialsInner.vue';
import PageRecipesInner from '~/components/pages/PageRecipesInner.vue';
import PageDefault from '~/components/pages/PageDefault.vue';

export default {
	name: 'page-inner',
	head: function head() {

		var globalHead = this.$store.state.settings._head || {},
		    localHead = this.content._head || {},
		    globalTitle = globalHead.title,
		    meta = _Object$assign(localHead.meta, globalHead.meta),
		    res = {};
		var localTitle = void 0;
		if (this.content.code == 'page-catalog-inner') {
			localTitle = localHead.title || 'Купить печенье ' + this.content.title + ' оптом и в розницу!';
		} else {
			localTitle = localHead.title || this.content.title;
		}

		_Object$keys(globalHead).forEach(function (el) {
			res[el] = globalHead[el];
		});

		_Object$keys(localHead).forEach(function (el) {

			if (Array.isArray(localHead[el]) && Array.isArray(res[el])) {
				res[el] = res[el].concat(localHead[el]);
			} else {
				res[el] = localHead[el];
			}
		});

		res.title = localTitle ? localTitle : globalTitle;
		if (meta.length == 0) {
			meta = {};
		}
		res.meta = meta;
		if (res.meta.Description == undefined) {
			res.meta.Description = {};
			res.meta.Description.content = res.title;
			res.meta.Description.hid = 'Description';
			res.meta.Description.name = 'Description';
		}
		res.meta.robots = {
			name: 'robots',
			hid: 'robots',
			content: 'noindex, nofollow'
		};
		return res;
	},


	props: {
		page: {
			type: Object,
			default: function _default() {
				return {};
			}
		}
	},

	components: {
		PageCatalogInner: PageCatalogInner,
		PageNewsInner: PageNewsInner,
		PageMaterialsInner: PageMaterialsInner,
		PageRecipesInner: PageRecipesInner,
		PageDefault: PageDefault
	},

	scrollToTop: true,

	data: function data() {
		return {
			content: {}
		};
	},

	computed: {
		innerType: function innerType() {
			return this.content.code || 'page-default';
		},
		crumbs: function crumbs() {
			var lang = '';
			switch (this.$route.params.lang) {
				case 'en':
					lang = '/eng';
					break;
			}
			return [{
				title: this.page.title,
				route: lang + '/' + this.$route.params.page
			}, {
				title: this.content.title,
				route: this.$route.path
			}];
		}
	},

	asyncData: function () {
		var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
			var params = _ref.params,
			    error = _ref.error,
			    query = _ref.query;

			var urlpath, _ref3, data;

			return _regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							if (!params.inner) {
								_context.next = 14;
								break;
							}

							_context.prev = 1;
							urlpath = 'inner/' + params.page + '/' + params.inner + '/' + params.lang;
							_context.next = 5;
							return axios.get(urlpath);

						case 5:
							_ref3 = _context.sent;
							data = _ref3.data;

							data.urlpath_inner = urlpath;

							return _context.abrupt('return', { content: data });

						case 11:
							_context.prev = 11;
							_context.t0 = _context['catch'](1);

							error({ statusCode: _context.t0.response.status, message: _context.t0.response.data });

						case 14:
							return _context.abrupt('return', { content: {} });

						case 15:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, this, [[1, 11]]);
		}));

		function asyncData(_x) {
			return _ref2.apply(this, arguments);
		}

		return asyncData;
	}(),
	beforeRouteEnter: function beforeRouteEnter(to, from, next) {
		// вызывается до подтверждения пути, соответствующего этому компоненту.
		// НЕ ИМЕЕТ доступа к контексту экземпляра компонента `this`,
		// так как к моменту вызова экземпляр ещё не создан!

		var url_arr = to.path.split('/').slice(1);
		for (var i in url_arr) {
			if (url_arr[i] == '') url_arr[i] = undefined;
		}
		if (url_arr[0] == 'eng') {
			to.params.lang = 'en';
			to.params.page = url_arr[1];
			to.params.inner = url_arr[2];
		} else {
			to.params.lang = 'ru';
		}
		/*to.params.ibre = url_arr;*/
		next();
	},
	beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
		if (!this.$route.params.inner) this.page.prevPagePath = from.fullPath;

		next();
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_page/_inner/_einner.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_page/_inner/_einner.vue
// module chunks = 1